/**
 * エラー関連処理
 * From: 1.0.0
 *
 * @packageDocumentation
 */

import {
  CommunicationError,
  toCommunicationError,
} from '../models/errors/communication/CommunicationError';

export type Errors = {
  [x: number]: (res: Response) => Promise<CommunicationError>;
};
export const defaultErrors: Errors = {
  400: async (res) =>
    toCommunicationError('WARNING', res, 'リクエストエラーが発生しました'),
  401: async (res) =>
    toCommunicationError('WARNING', res, 'ユーザ認証に失敗しました'),
  403: async (res) =>
    toCommunicationError('WARNING', res, 'アクセス権がありません'),
  404: async (res) =>
    toCommunicationError('WARNING', res, 'リソースが存在しませんでした'),
  405: async (res) =>
    toCommunicationError('WARNING', res, '無効なメソッドです'),
  407: async (res) =>
    toCommunicationError('WARNING', res, 'プロキシサーバ認証に失敗しました'),
  409: async (res) =>
    toCommunicationError('WARNING', res, 'コンフリクトが発生しました'),
  500: async (res) =>
    toCommunicationError('FATAL', res, 'サーバエラーが発生しました'),
  502: async (res) =>
    toCommunicationError(
      'WARNING',
      res,
      'サーバエラーが発生しました (BAD GATEWAY)'
    ),
  503: async (res) =>
    toCommunicationError(
      'WARNING',
      res,
      'サーバエラーが発生しました (サーバの準備ができていません)'
    ),
  504: async (res) =>
    toCommunicationError(
      'WARNING',
      res,
      'サーバエラーが発生しました (GATEWAY TIMEOUT)'
    ),
};
export const undefinedErrors = async (res: Response) => {
  const resText = JSON.parse(await res.text().then());
  let message = '';
  if (resText.message) {
    message += resText.message;
    if (resText.description) message += ` (${resText.description})`;
  } else if (resText.description) message += resText.description;

  return new CommunicationError('ERROR', res, undefined, message);
};
